import { render } from "./AdvisorHeader.vue?vue&type=template&id=5b12aa32"
import script from "./AdvisorHeader.vue?vue&type=script&lang=js"
export * from "./AdvisorHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__